import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f337760"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "facility-info" }
const _hoisted_3 = { class: "overline" }
const _hoisted_4 = { class: "ion-margin-top" }
const _hoisted_5 = { class: "ion-text-wrap" }
const _hoisted_6 = { class: "ion-text-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "ion-text-wrap"
}
const _hoisted_8 = {
  key: 1,
  class: "ion-text-wrap"
}
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = { class: "overline" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "ion-text-wrap" }
const _hoisted_13 = { class: "overline" }
const _hoisted_14 = { class: "overline" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "external-mappings" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, /*#__PURE__*/_toDisplayString("added"), -1))
const _hoisted_20 = { class: "external-mappings" }
const _hoisted_21 = {
  key: 0,
  class: "ion-margin-start overline"
}
const _hoisted_22 = {
  key: 1,
  class: "ion-text-center ion-padding-top"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_back_button, {
                slot: "start",
                "default-href": "/tabs/find-facilities"
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Facility details")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.current?.facilityId)
            ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ion_card, { class: "facility-info facility-details" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        lines: "none",
                        class: "ion-margin-top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.current.facilityId), 1),
                              _createElementVNode("h1", null, _toDisplayString(_ctx.current.facilityName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.renameFacility())),
                            fill: "outline"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate('Edit')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.bookmarkOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_select, {
                              label: _ctx.translate('Facility Type'),
                              interface: "popover",
                              modelValue: _ctx.parentFacilityTypeId,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parentFacilityTypeId) = $event)),
                              onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getFacilityTypesByParentTypeId()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select_option, { value: "PHYSICAL_STORE" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate('Physical Store')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select_option, { value: "DISTRIBUTION_CENTER" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate('Distribution Center')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["label", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.bookmarksOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_select, {
                              label: _ctx.translate('Facility SubType'),
                              interface: "popover",
                              modelValue: _ctx.facilityTypeId,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.facilityTypeId) = $event)),
                              onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateFacilityType()))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilityTypeIdOptions, (type, facilityTypeId) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: facilityTypeId,
                                    value: facilityTypeId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(type.description ? type.description : facilityTypeId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["label", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          lines: "none",
                          class: "ion-margin-bottom"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.lockClosedOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_toggle, {
                              checked: !!_ctx.current.closedDate,
                              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.closeFacility($event)), ["prevent"]))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate('Permanently Closed')), 1)
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("section", null, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Address and contact details")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.postalAddress?.address1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.postalAddress.toName), 1),
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.postalAddress.address1), 1),
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.postalAddress.address2), 1),
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.postalAddress.directions), 1),
                                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.postalAddress.postalCode ? `${_ctx.postalAddress.city}, ${_ctx.postalAddress.postalCode}` : _ctx.postalAddress.city), 1),
                                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.postalAddress.countryGeoName ? `${_ctx.postalAddress.stateGeoName}, ${_ctx.postalAddress.countryGeoName}` : _ctx.postalAddress.stateGeoName), 1),
                                      (_ctx.contactDetails?.telecomNumber)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(`${_ctx.contactDetails.telecomNumber?.countryCode}-${_ctx.contactDetails.telecomNumber?.contactNumber}`), 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.contactDetails?.emailAddress)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.contactDetails.emailAddress?.infoString), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                onClick: _ctx.openAddressModal
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("Edit")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ], 64))
                          : (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              expand: "block",
                              fill: "outline",
                              onClick: _ctx.openAddressModal
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Add")) + " ", 1),
                                _createVNode(_component_ion_icon, {
                                  slot: "end",
                                  icon: _ctx.addCircleOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Latitude & Longitude")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.postalAddress?.latitude || _ctx.postalAddress.latitude == 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("These values are used to help customers lookup how close they are to your stores when they are finding nearby stores.")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.translate("Facility zipcode")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_text, {
                                        color: _ctx.isRegenerationRequired ? 'danger' : ''
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.postalAddress.postalCode), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.translate("Latitude")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.postalAddress.latitude), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.translate("Longitude")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.postalAddress.longitude), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  disabled: !_ctx.postalAddress.address1,
                                  onClick: _ctx.openGeoPointModal
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("Edit")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"]),
                                _createVNode(_component_ion_button, {
                                  slot: "end",
                                  fill: "clear",
                                  color: "medium",
                                  onClick: _ctx.openLatLongPopover
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.ellipsisVerticalOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ], 64))
                          : (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              expand: "block",
                              fill: "outline",
                              disabled: !_ctx.postalAddress.address1,
                              onClick: _ctx.openGeoPointModal
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Add")) + " ", 1),
                                _createVNode(_component_ion_icon, {
                                  slot: "end",
                                  icon: _ctx.addCircleOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"]))
                      ]),
                      _: 1
                    })
                  ]),
                  (!_ctx.facilityCalendar.calendarId)
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("Operating hours")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.translate("Selected TimeZone")), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.current?.facilityTimeZone || '-') + " ", 1),
                                  (_ctx.current?.facilityTimeZone)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.getCurrentTime(_ctx.current?.facilityTimeZone, _ctx.dateTimeFormat)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                slot: "end",
                                fill: "outline",
                                color: "dark",
                                onClick: _ctx.openTimeZoneModal
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate(_ctx.current?.facilityTimeZone ? "Change" : "Add")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Select a saved calendar of store hours or create a new calendar")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_radio_group, {
                            modelValue: _ctx.selectedCalendarId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCalendarId) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendars.slice(0,3), (calendar, index) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: index,
                                  lines: "none"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_radio, {
                                      value: calendar.calendarId
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(calendar.description ? calendar.description : calendar.calendarId), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (_ctx.calendars?.length > 3)
                            ? (_openBlock(), _createBlock(_component_ion_item, {
                                key: 0,
                                button: "",
                                lines: "none",
                                onClick: _ctx.addOperatingHours
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.calendars.length - 3) + " " + _toDisplayString(_ctx.translate("Others")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_icon, {
                                    slot: "end",
                                    icon: _ctx.chevronForwardOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_item, {
                            button: "",
                            lines: "none",
                            onClick: _ctx.addCustomSchedule
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("Custom schedule")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                color: "primary",
                                icon: _ctx.addCircleOutline,
                                button: ""
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            expand: "block",
                            disabled: !_ctx.selectedCalendarId,
                            onClick: _ctx.associateCalendarToFacility
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Add operating hours")) + " ", 1),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.addCircleOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.translate("Operating hours")), 1),
                                _createVNode(_component_ion_card_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.facilityCalendar.description || _ctx.facilityCalendar.calendarId), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_ion_button, {
                                color: "medium",
                                fill: "clear",
                                class: "ion-no-padding",
                                onClick: _ctx.openOperatingHoursPopover
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.ellipsisVerticalOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.translate("Selected TimeZone")), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.current?.facilityTimeZone || '-') + " ", 1),
                                  (_ctx.current?.facilityTimeZone)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.getCurrentTime(_ctx.current?.facilityTimeZone, _ctx.dateTimeFormat)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                onClick: _ctx.openTimeZoneModal,
                                slot: "end",
                                fill: "outline",
                                color: "dark"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate(_ctx.current?.facilityTimeZone ? "Change" : "Add")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, { lines: "none" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
                                return (_openBlock(), _createBlock(_component_ion_item, { key: day }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.translate(day.charAt(0).toUpperCase() + day.slice(1))), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.facilityCalendar[day+'StartTime'] ? _ctx.getOpenEndTime(_ctx.facilityCalendar[day+'StartTime'], _ctx.facilityCalendar[day+'Capacity']) : _ctx.translate('Closed')), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Product Stores")), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.facilityProductStores?.length)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectProductStores())),
                                  fill: "clear"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.addCircleOutline,
                                      slot: "end"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" " + _toDisplayString(_ctx.translate("Add")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilityProductStores, (store) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: store.productStoreId
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getProductStore(store.productStoreId)?.storeName || store.productStoreId), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (_ctx.shopifyShopIdForProductStore(store.productStoreId) !== '' && _ctx.shopifyShopIdForProductStore(store.productStoreId) === _ctx.current.primaryFacilityGroupId)
                                ? (_openBlock(), _createBlock(_component_ion_badge, {
                                    key: 0,
                                    slot: "end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.translate("primary store")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_button, {
                                slot: "end",
                                fill: "clear",
                                color: "medium",
                                onClick: ($event: any) => (_ctx.productStorePopover($event, store))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.ellipsisVerticalOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (!_ctx.facilityProductStores?.length)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              expand: "block",
                              fill: "outline",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectProductStores()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Add")) + " ", 1),
                                _createVNode(_component_ion_icon, {
                                  slot: "end",
                                  icon: _ctx.addCircleOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate('Map Link')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate('Give customers on your website a direct link to this facility on a mapping service like Google Maps.')), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.contactDetails?.googleMapUrl?.infoString)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.contactDetails.googleMapUrl.infoString), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                onClick: _ctx.editMapUrl
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate('Edit')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                href: _ctx.mapUrl,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate('Preview')) + " ", 1),
                                  _createVNode(_component_ion_icon, {
                                    slot: "end",
                                    icon: _ctx.openOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }, 8, ["href"])
                            ], 64))
                          : (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              fill: "clear",
                              onClick: _ctx.editMapUrl
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate('Add')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("section", null, [
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Fulfillment Settings")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_toggle, {
                            checked: _ctx.current.allowPickup,
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.updateFulfillmentSetting($event, 'PICKUP')), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Allow pickup")), 1)
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_toggle, {
                            checked: _ctx.current.useOMSFulfillment,
                            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.updateFulfillmentSetting($event, 'OMS_FULFILLMENT')), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Uses native fulfillment app")), 1)
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_toggle, {
                            checked: _ctx.current.generateShippingLabel,
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.updateFulfillmentSetting($event, 'AUTO_SHIPPING_LABEL')), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Generate shipping labels")), 1)
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { lines: "full" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            label: _ctx.translate('Days to ship'),
                            modelValue: _ctx.defaultDaysToShip,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.defaultDaysToShip) = $event)),
                            type: "number",
                            min: "0",
                            placeholder: _ctx.translate('days to ship')
                          }, null, 8, ["label", "modelValue", "placeholder"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        expand: "block",
                        onClick: _ctx.updateDefaultDaysToShip
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.translate("Update days to ship")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Sell inventory online")), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.current.inventoryGroups?.length)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openCreateInventoryGroupModal())),
                                fill: "clear"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.addCircleOutline,
                                    slot: "end"
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.translate("Add")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.current.inventoryGroups?.length ? _ctx.translate("Select which channels this facility publishes inventory too.") : _ctx.translate("There are no inventory channels setup yet")), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.inventoryGroups, (inventoryGroup) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: inventoryGroup.facilityGroupId
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_toggle, {
                              checked: inventoryGroup.isChecked,
                              onClick: _withModifiers(($event: any) => (_ctx.updateSellInventoryOnlineSetting($event, inventoryGroup)), ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inventoryGroup?.facilityGroupName), 1)
                              ]),
                              _: 2
                            }, 1032, ["checked", "onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (!_ctx.current.inventoryGroups?.length)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            expand: "block",
                            fill: "outline",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openCreateInventoryGroupModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Add")) + " ", 1),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.addCircleOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Online Order Fulfillment")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.translate("Configure the order fulfillment capacity of your facility.")) + " ", 1),
                          _hoisted_16,
                          _hoisted_17,
                          _createTextVNode(" " + _toDisplayString(_ctx.translate("Setting fulfillment capacity to 0 disables new order from being allocated to this facility. Leave this empty if this facility's fulfillment capacity is unrestricted.")), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.current.orderLimitType === 'custom')
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 0,
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.current.orderCount), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_progress_bar, {
                                class: "ion-margin",
                                value: _ctx.current.orderCount / _ctx.current.maximumOrderLimit
                              }, null, 8, ["value"]),
                              _createVNode(_component_ion_chip, {
                                outline: "",
                                onClick: _ctx.changeOrderLimitPopover
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.current.maximumOrderLimit), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }))
                        : (_ctx.current.orderLimitType === 'unlimited')
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 1,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("orders allocated today", { orderCount: _ctx.current.orderCount })), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_chip, {
                                  outline: "",
                                  onClick: _ctx.changeOrderLimitPopover
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("Unlimited")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_ion_item, {
                              key: 2,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("orders in fulfillment queue", { orderCount: _ctx.current.orderCount })), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_chip, {
                                  outline: "",
                                  onClick: _ctx.changeOrderLimitPopover,
                                  color: "danger",
                                  fill: "outline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.current.maximumOrderLimit), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })),
                      _createVNode(_component_ion_item, {
                        lines: "none",
                        detail: "",
                        button: "",
                        onClick: _ctx.openFacilityOrderCountModal
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("View order count history")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.facilityTypes[_ctx.current.facilityTypeId]?.description ? _ctx.translate(`${_ctx.facilityTypes[_ctx.current.facilityTypeId]?.description} logins`) : _ctx.translate('logins', { facilitytype:`${_ctx.current.facilityTypeId}` })), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.current.facilityLogins?.length)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.createFacilityLoginModal())),
                                fill: "clear"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.addCircleOutline,
                                    slot: "end"
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.translate("Add")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.facilityLogins, (facilityLogin) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: facilityLogin.userLoginId
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, { slot: "start" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Image, {
                                  src: _ctx.getImageUrl(facilityLogin.objectInfo)
                                }, null, 8, ["src"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(facilityLogin.groupName) + " ", 1),
                                _createElementVNode("p", null, _toDisplayString(facilityLogin.partyId), 1),
                                _createElementVNode("p", null, _toDisplayString(facilityLogin.userLoginId), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_button, {
                              slot: "end",
                              fill: "clear",
                              size: "default",
                              color: "medium",
                              onClick: ($event: any) => (_ctx.openFacilityLoginActionPopover($event, facilityLogin))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.ellipsisVerticalOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (!_ctx.current.facilityLogins?.length)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            expand: "block",
                            fill: "outline",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.createFacilityLoginModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Add")) + " ", 1),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.addCircleOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_ion_segment, {
                  scrollable: "",
                  modelValue: _ctx.segment,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.segment) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment_button, {
                      value: "external-mappings",
                      layout: "icon-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.globeOutline }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("External mappings")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, {
                      value: "staff",
                      layout: "icon-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.personOutline }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Staff")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, {
                      value: "locations",
                      layout: "icon-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.locationOutline }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Locations")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, {
                      value: "groups",
                      layout: "icon-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.albumsOutline }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Groups")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.segment === 'external-mappings')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        onClick: _ctx.openExternalMappingPopover
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.addCircleOutline,
                            slot: "start"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.translate("Map facility to an external system")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.shopifyFacilityMappings, (shopifyFacilityMapping, index) => {
                          return (_openBlock(), _createBlock(_component_ion_card, { key: index }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.translate("Shopify facility")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(shopifyFacilityMapping.name) + " ", 1),
                                      _createElementVNode("p", null, _toDisplayString(shopifyFacilityMapping.shopId), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(shopifyFacilityMapping.shopifyLocationId), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (shopifyFacilityMapping.myshopifyDomain)
                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                    key: 0,
                                    lines: "full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(shopifyFacilityMapping.myshopifyDomain + '/admin'), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_button, {
                                        color: "medium",
                                        fill: "clear",
                                        onClick: ($event: any) => (_ctx.goToLink(`${shopifyFacilityMapping.myshopifyDomain + '/admin'}`))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.openOutline }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                onClick: ($event: any) => (_ctx.editShopifyFacilityMapping(shopifyFacilityMapping))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("Edit")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                color: "danger",
                                onClick: ($event: any) => (_ctx.removeShopifyFacilityMapping(shopifyFacilityMapping))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("Remove")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.facilityMappings, (mapping, index) => {
                          return (_openBlock(), _createBlock(_component_ion_card, { key: index }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.externalMappingTypes[mapping.facilityIdenTypeId]), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    onClick: ($event: any) => (_ctx.copyToClipboard(mapping.idValue, 'Copied to clipboard'))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.copyOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.translate('Identification')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(mapping.idValue), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                onClick: ($event: any) => (_ctx.editFacilityMapping(mapping))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("Edit")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                color: "danger",
                                onClick: ($event: any) => (_ctx.removeFacilityMapping(mapping))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("Remove")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_ctx.current.externalId)
                          ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_header, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.translate('Facility External ID')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_button, {
                                      fill: "clear",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.copyToClipboard(_ctx.current.externalId, 'Copied to clipboard')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.copyOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, { lines: "full" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.translate('Identification')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.current.externalId), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => {$event.target.blur(); _ctx.editFacilityExternalId()})
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("Edit")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  color: "danger",
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.removeFacilityExternalID()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("Remove")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : (_ctx.segment === 'staff')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_ion_button, {
                          fill: "outline",
                          onClick: _ctx.addStaffMemberModal
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.addCircleOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.translate("Staff member")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilityParties, (party, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list-item staff",
                            key: index
                          }, [
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.personOutline,
                                  slot: "start"
                                }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(party.fullName) + " ", 1),
                                    _createElementVNode("p", null, _toDisplayString(party.partyId), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_label, { class: "tablet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_chip, { outline: "" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.partyRoles[party.roleTypeId] ? _ctx.partyRoles[party.roleTypeId] : '-'), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("p", null, _toDisplayString(_ctx.translate("role")), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_label, { class: "tablet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_chip, { outline: "" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getDate(party.fromDate)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_19
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_button, {
                              onClick: ($event: any) => (_ctx.removePartyFromFacility(party)),
                              fill: "clear",
                              color: "medium"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.closeCircleOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        }), 128))
                      ], 64))
                    : (_ctx.segment == 'locations')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            onClick: _ctx.addLocationModal
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.addCircleOutline,
                                slot: "start"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.translate("Internal locations")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.locations, (location) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "list-item",
                              key: location.locationSeqId
                            }, [
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.locationOutline,
                                    slot: "start"
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(location.locationSeqId) + " ", 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.locationTypes[location.locationTypeEnumId]), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_label, { class: "tablet" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(location.areaId) + " ", 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.translate("area")), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(location.aisleId) + " ", 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.translate("aisle")), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(location.sectionId) + " ", 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.translate("section")), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_label, { class: "tablet" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(location.levelId) + " ", 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.translate("level")), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(location.positionId ? location.positionId : '-') + " ", 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.translate("sequence")), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                color: "medium",
                                onClick: ($event: any) => (_ctx.openLocationDetailsPopover($event, location))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.ellipsisVerticalOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128))
                        ], 64))
                      : (_ctx.segment == 'groups')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(_component_ion_button, {
                              fill: "outline",
                              onClick: _ctx.addFacilityGroupModal
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.addCircleOutline,
                                  slot: "start"
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.translate("Link to groups")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createElementVNode("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.groupInformation, (group, index) => {
                                return (_openBlock(), _createBlock(_component_ion_card, { key: index }, {
                                  default: _withCtx(() => [
                                    (_ctx.getFacilityGroupTypeDesc(group.facilityGroupTypeId))
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.getFacilityGroupTypeDesc(group.facilityGroupTypeId)), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ion_card_header, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(group.facilityGroupName), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_ion_card_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(group.facilityGroupId), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createVNode(_component_ion_button, {
                                          fill: "clear",
                                          onClick: ($event: any) => (_ctx.removeFacilityFromGroup(group.facilityGroupId))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "icon-only",
                                              icon: _ctx.unlinkOutline
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (group.description)
                                      ? (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 1,
                                          lines: "none"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(group.description), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
              ]))
            : (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("main", _hoisted_22, _toDisplayString(_ctx.translate("Failed to fetch facility information")), 1))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}